'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/**
 * Interface for exposure logging
 *
 * Implement this interface when creating a new experiment exposure logger.
 *
 * Your implementation is in charge to catch errors and log them if it is the case.
 *
 * @interface
 */
var ExposureLogger = function () {
  function ExposureLogger() {
    _classCallCheck(this, ExposureLogger);
    if (this.constructor === ExposureLogger) {
      throw new Error('Cannot instantiate a ExposureLogger. Please extend and implement.');
    }
  }

  /**
   * Logs exposure by translating from an {@link EvaluationData} to a call to the exposure logger implementation
   *
   * @param {EvaluationData} evaluationData - details for the evaluated experiment to log exposure
   * @param {object} loggerParams - any extra options or data custom to the logger implementation
   */
  // eslint-disable-next-line no-unused-vars

  _createClass(ExposureLogger, [{
    key: 'logExposure',
    value: function logExposure(evaluationData, loggerParams) {
      throw new Error('Not implemented');
    }
  }]);
  return ExposureLogger;
}();
exports.default = ExposureLogger;